//

//import React, {ChangeEvent, useState, useEffect} from "react";
import React, { useState } from "react";
import './quickacces.scss';
import { stickynoteobj } from '../../Entity/stickynoteobj';
import { ColorPicker, getColorFromString, IColor } from 'office-ui-fabric-react/lib/index';
//import { mergeStyleSets, HighContrastSelector } from 'office-ui-fabric-react/lib/Styling';
//import { updateA } from 'office-ui-fabric-react/lib/utilities/color/updateA';
//https://developer.microsoft.com/en-us/fluentui?fabricVer=6#/controls/web/colorpicker
//https://www.npmjs.com/package/react-confirm-alert
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
//import * as $ from "jquery";
interface Props {
  Note: stickynoteobj;
  UpdateList;
}

const StickynoteItem: React.FC<Props> = (props) => {
  const [notecolor, setnotecolor] = useState<string>('');
  const [currentprop, setCurrentColorProp] = useState<string>('');

  const dropNote = (event) => {
    event.preventDefault();
    let parentboundary = { left: 0, width: 0, top: 0 }, CurrentItemboundary = { left: 0, width: 0, top: 0 };
    {
      parentboundary.left = event.target.parentElement.getBoundingClientRect().left;
      parentboundary.width = event.target.parentElement.getBoundingClientRect().width;
      parentboundary.top = event.target.parentElement.getBoundingClientRect().top;

      CurrentItemboundary.left = event.target.getBoundingClientRect().left;
      CurrentItemboundary.width = event.target.getBoundingClientRect().width;
      CurrentItemboundary.top = event.target.getBoundingClientRect().top;

    }


    let leftval = event.pageX - parentboundary.left - 80;
    let topval = event.pageY - (parentboundary.top + window.scrollY - 20);
    if (leftval < 10) {
      leftval = 10;
    } else if (leftval + CurrentItemboundary.width > parentboundary.width) {
      leftval = parentboundary.width - CurrentItemboundary.width;
    }
    let mintop = 20 + (1.2 * props.Note.rotate);
    if (topval < mintop) {
      topval = mintop;
    }
    if (window.navigator.userAgent.indexOf('Firefox') > 0) {
      leftval -= 80;
      topval -= 190;
    }


    event.target.style.left = `${leftval}px`;
    event.target.style.top = `${topval}px`;
    props.Note.left = leftval;
    props.Note.top = topval;
    props.UpdateList('Update_NOTE', props.Note);

  };
  const UpdateColor = (ev: React.SyntheticEvent<HTMLElement>, colorObj: IColor) => {
    props.Note[currentprop] = '#' + colorObj.hex;
    setnotecolor(props.Note[currentprop]);
    props.UpdateList('Update_NOTE', props.Note);
  };
  const ShowHidePicker = (prop, show) => {
    if (show) {
      setnotecolor(props.Note[prop]);
      setCurrentColorProp(prop);
    }
    setshowcolorPicker(show);
  }

  const [showcolorPicker, setshowcolorPicker] = useState<boolean>(false);
  let color: IColor = getColorFromString(notecolor);

  if (props.Note == null) {
    return (<span></span>);
  }
  let noteclass = "noteitem notepossitionForlg";
  if (window.outerWidth < 600) {
    noteclass = "noteitem notepossitionForsm";
  }
  return (
    <div className={noteclass} onDragEnd={dropNote}
      onDragStart={event => {
        //event.nativeEvent.dataTransfer.setData('text', 'anything')
      }}
      draggable="true" onClick={(event) => {

        event.stopPropagation();
        let newindex = Date.now().toString().substring(5);
        event.currentTarget.style.zIndex = newindex;
      }}
      style={{ top: props.Note.top, left: props.Note.left }}
    >
      {showcolorPicker ? (
        <div className="colorpickercontainer">
          <ColorPicker color={color} onChange={UpdateColor} alphaSliderHidden={true} />
          <i className="ms-Icon ms-Icon--Clear closepicker" onClick={() => {
            ShowHidePicker(null, false)
          }}></i>
        </div>) : null}
      <div className="noteblock"
        style={{ transform: `rotate(${props.Note.rotate}deg)` }}
      >
        <div className="noteheading" style={{ backgroundColor: props.Note.color }}>
          <div className="notepin"></div>
          {/*  <img className="notepin" src={require('../../Images/pin3.png')} /> */}
          <i title="Maximise" className="ms-Icon ms-Icon--ScaleUp notescalup"
            onClick={() => {
              confirmAlert({
                customUI: ({ onClose }) => {
                  return (
                    <div className='custom-ui' style={{ backgroundColor: props.Note.color }}>
                      <div dangerouslySetInnerHTML={{ __html: props.Note.body }}>

                      </div>
                      <button onClick={onClose}>Close</button>

                    </div>
                  );
                }
              });

            }}
          >

          </i>
          <i title="Change font color" className="ms-Icon ms-Icon--FontColor notefontcolor"
            onClick={() => {
              ShowHidePicker('fontcolor', true)
            }}
          ></i>
          <i className="ms-Icon ms-Icon--ColorSolid notecolor" onClick={() => {
            ShowHidePicker('color', true)
          }} title="Change background color"></i>
          <i className="ms-Icon ms-Icon--ErrorBadge noteclose" title="Remove note"
            onClick={() => {
              confirmAlert({
                customUI: ({ onClose }) => {
                  return (
                    <div className='custom-ui' style={{ backgroundColor: props.Note.color }}>
                      <h1>Are you sure?</h1>
                      <p>You want to delete this note?</p>
                      <button onClick={onClose}>No</button>
                      <button
                        onClick={() => {

                          props.UpdateList('Delete_NOTE', props.Note);
                          onClose();
                        }}
                      >
                        Yes, Delete it!
                      </button>
                    </div>
                  );
                }
              });

            }}
          ></i>
        </div>
        <div className="notebody" onFocus={(e) => { console.log('focused') }}
          onBlur={(e) => {
            props.UpdateList('Update_NOTE', props.Note);
          }}
          onInput={(e) => {
            props.Note.body = e.currentTarget.innerHTML;
          }}
          onChange={(e) => { console.log(e) }} contentEditable="true"
          style={{ backgroundColor: props.Note.color, color: props.Note.fontcolor }}

          onClick={(event) => {
            if (showcolorPicker) {
              ShowHidePicker(null, false);
            }
          }}
          dangerouslySetInnerHTML={{ __html: props.Note.body }}
        ></div>

      </div>
    </div>

  )
};

export default StickynoteItem;